import { DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  Popconfirm,
  Select,
  message,
} from "antd";
import { SpellCheckTextArea } from "../../../../components/spellcheck";
import axios from "axios";
import MessageReadStatus from "../../../../components/readreceipts/MessageReadStatus";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  AiOutlineClose,
  AiOutlineFile,
  AiOutlineFilePdf,
  AiOutlineUpload,
} from "react-icons/ai";
import { useQuery, useQueryClient } from "react-query";
import { cloudFrontUrl, serverUrl } from "../../../../nestserver";
import {
  uploadDoc,
} from "../../../../services/upload.service";
const { Option } = Select;

const InstructorClassBroadcast = () => {
  const [form] = Form.useForm();
  const inputRef = useRef(null);
  const queryClient = useQueryClient();
  const [classId, setClassId] = useState();
  const [subjectId, setSubjectId] = useState();
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [messageData, setMessageData] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState("");
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [classSubjectData, setClassSubjectData] = useState([]);

  const handleClassChange = (values) => {
    form.resetFields(["subject"]);
    setClassId(values);
    setSubjectId(null);
  };
  const handleImageClick = (src) => {
    setModalImageSrc(src);
    setIsModalVisible(true);
  };

  const handleVideoClick = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setVideoModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setModalImageSrc("");
  };

  const handleSubjectChange = (subjectId) => {
    setSubjectId(subjectId);
  };
  //fetch class
  const fetchClasses = async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/teachers/classes",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };
  const classes = useQuery("classes", fetchClasses);

  //fetch class subjects
  const fetchClassSubject = React.useCallback(async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/classes/" + classId,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    setClassSubjectData(res?.data);
    return res.data;
  }, [classId]);

  //get class broadcasting
  const fetchClassConversation = async (id) => {
    let url = serverUrl + "/conversations/subject/" + id;
    if (id === "all-subjects") {
      url = serverUrl + "/conversations/class/" + classId;
    }
    const res = await axios({
      method: "get",
      url: url,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };
  const classConversationDetails = useQuery(
    ["conversations", subjectId],
    () => fetchClassConversation(subjectId),
    { enabled: !!subjectId },
  );

  const handleFileSelect = async (event) => {
    const files = event.target.files;

    if (!files || files?.length === 0) return;

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "audio/mpeg",
      "audio/mp3",
      "video/mp4",
      "audio/wav",
      "audio/webm",
    ];

    const maxTotalFiles = 15;
    const responses = [];

    try {
      for (const file of files) {
        if (!allowedTypes.includes(file.type)) {
          message.error(
            `Invalid file type for ${file.name}. Please upload PDF, JPG, PNG, MP3, MP4, or audio files only.`,
          );
          continue;
        }

        let folder = "images";
        let mediaType = "IMAGE";

        if (file.type === "application/pdf") {
          folder = "pdf";
          mediaType = "PDF";
        } else if (file.type.startsWith("image/")) {
          folder = "images";
          mediaType = "IMAGE";
        } else if (file.type.startsWith("video/")) {
          folder = "video";
          mediaType = "VIDEO";
        } else if (file.type.startsWith("audio/")) {
          folder = "audio";
          const isVoice =
            file.name.toLowerCase().endsWith(".wav") ||
            file.name.toLowerCase().endsWith(".webm");
          mediaType = isVoice ? "VOICE" : "AUDIO";
        }

        const res = await uploadDoc({ file }, folder, (progress) => {
          // message.loading(`Uploading ${file.name}: ${progress}%`, 0.5);
        });

        responses.push({ ...res, mediaType });
      }

      message.success("Files Upload Success");
      setUploadedDocs((prevDocs) => {
        const newDocs = responses.reduce((acc, item) => {
          if (item?.files?.name && item?.id) {
            const mediaItem = {
              name: item?.files?.name,
              id: item?.id,
            };
            if (item?.mediaType) {
              mediaItem.type = item?.mediaType;
            }
            acc.push(mediaItem);
          }
          return acc;
        }, []);

        const updatedDocs = Array.isArray(prevDocs)
          ? [...prevDocs, ...newDocs]
          : newDocs;

        return updatedDocs.slice(0, maxTotalFiles);
      });
    } catch (error) {
      console.error(error);
      message.error("Files Upload Failed");
    }
  };
  const handleMessageChange = (e) => {
    setMessageData(e.target.value);
  };

  const handleSubmit = async () => {
    const payload = {
      type: subjectId === "all-subjects" ? "class_broadcast" : "broadcast",
      conversation_id: classConversationDetails?.data?.result?._id
        ? classConversationDetails?.data?.result?._id
        : null,
      target_id: null,
      subject_id: subjectId !== "all-subjects" ? subjectId : null,
      class_id: subjectId === "all-subjects" ? classId : null,
      media: uploadedDocs && uploadedDocs?.length > 0 ? uploadedDocs : [],
      message: messageData ? messageData : null,
    };
    axios
      .post(serverUrl + "/conversations", payload, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      })
      .then((res) => {
        message.success(res?.data?.result?.message);
        setMessageData("");
        setUploadedDocs([]);
        queryClient.invalidateQueries(["conversations", subjectId]);
      })
      .catch((err) => {
        if (err?.response?.data?.error?.errors) {
          message.error(err?.response?.data?.error?.errors);
        }
      });
  };
  const onRemove = (index) => {
    setUploadedDocs((oldDoc) => oldDoc.filter((_, i) => i !== index));
    message.success("File Removed");
  };

  const deleteMessage = (messageId) => {
    axios({
      method: "delete",
      url:
        serverUrl +
        "/conversations/" +
        classConversationDetails?.data?.result?._id +
        "/message/" +
        messageId,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    })
      .then((res) => {
        queryClient.invalidateQueries(["conversations", subjectId]);
        message.success(res?.data?.result?.message);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (classId) {
      fetchClassSubject();
    }
  }, [classId, fetchClassSubject]);
  useEffect(() => {
    if (uploadedDocs?.length > 0 && inputRef.current) {
      inputRef.current.focus();
    }
  }, [uploadedDocs]);

  // Helper function to determine media folder and type
  const getMediaInfo = (item) => {
    let folder = "images"; // Default
    let mediaType = item?.type;

    if (item?.type) {
      if (item.type === "IMAGE") folder = "images";
      else if (item.type === "PDF") folder = "pdf";
      else if (item.type === "VIDEO") folder = "video";
      else if (item.type === "AUDIO" || item.type === "VOICE") folder = "audio";
    } else {
      // Fallback to extension-based detection if type is not explicitly set
      const name = item?.name?.toLowerCase() || "";
      if (name.endsWith(".pdf")) {
        folder = "pdf";
        mediaType = "PDF";
      } else if (name.endsWith(".mp4")) {
        folder = "video";
        mediaType = "VIDEO";
      } else if (name.endsWith(".mp3")) {
        folder = "audio";
        mediaType = "AUDIO";
      } else if (name.endsWith(".wav") || name.endsWith(".webm")) {
        folder = "audio";
        mediaType = "VOICE";
      } else if (
        name.endsWith(".jpeg") ||
        name.endsWith(".jpg") ||
        name.endsWith(".png")
      ) {
        folder = "images";
        mediaType = "IMAGE";
      }
    }
    return { folder, mediaType };
  };
  return (
    <div>
      <div className="p-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full screen-height "
        >
          <div className="flex gap-4 min-height">
            <div style={{ width: "30%" }} className="message-left-part">
              <Form
                form={form}
                name="dynamic_rule"
                layout="vertical"
                autoComplete="off"
              >
                <Form.Item name="class" label="Class" className="w-30">
                  <Select
                    showSearch
                    showArrow
                    placeholder="Select Class"
                    className="w-full bg-gray-300"
                    style={{
                      border: "6px",
                      backgroundColor: "#EBEBEB",
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    onChange={handleClassChange}
                  >
                    {classes?.isSuccess &&
                      classes?.data?.map((data) => {
                        return (
                          <Option key={data._id} value={data._id}>
                            {data.name}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Form.Item name="subject" label="Subject" className="w-30">
                  <div
                    style={{
                      maxHeight: "calc(100vh - 320px)",
                      overflowY: "auto",
                    }}
                  >
                    {classId && (
                      <div className="pt-2 text-base cursor-pointer">
                        <div
                          onClick={() => {
                            setSubjectId(null);
                            setSubjectId("all-subjects");
                          }}
                          type="primary"
                          size="large"
                          className={`cursor-pointer ${
                            subjectId === "all-subjects"
                              ? "active-message"
                              : "message-card"
                          }`}
                        >
                          <div className="flex justify-between">
                            <div>All Subjects</div>
                          </div>
                        </div>
                      </div>
                    )}
                    {classSubjectData &&
                      classSubjectData?.subjects?.map((data) => (
                        <div
                          className="pt-2 text-base cursor-pointer"
                          key={data?._id}
                        >
                          <div
                            onClick={() => handleSubjectChange(data?._id)}
                            type="primary"
                            size="large"
                            className={`cursor-pointer ${
                              subjectId === data?._id
                                ? "active-message"
                                : "message-card"
                            }`}
                          >
                            <div className="flex justify-between">
                              <div>{data?.name}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </Form.Item>
              </Form>
            </div>
            <div style={{ width: "70%" }} className="instructor-broadcast">
              {subjectId ? (
                <>
                  <div className="flex justify-between items-center pb-4">
                    <h1 className="pb-2 text-base font-semibold">
                      Class BroadCast
                    </h1>
                    <AiOutlineClose
                      size={20}
                      onClick={() => {
                        setSubjectId(null);
                        setClassId(null);
                        setUploadedDocs([]);
                        setClassSubjectData([]);
                        form.resetFields(["subject", "class"]);
                      }}
                      className="cursor-pointer"
                    />
                  </div>
                  <div
                    className="message-chat-content pt-8"
                    style={{ width: "70%", marginLeft: "auto" }}
                  >
                    {classConversationDetails &&
                      classConversationDetails?.data?.result?.messages?.map(
                        (message) => {
                          return (
                            <div className="pt-4" key={message?._id}>
                              <div className="flex items-center gap-4 pb-4 justify-end">
                                <div className="flex flex-col gap-1">
                                  <span className="flex items-center gap-2">
                                    {moment(message?.createdAt).format(
                                      "DD-MM-YYYY hh:mm A",
                                    )}
                                    <MessageReadStatus message={message} apiPrefix="/conversations" />
                                  </span>
                                </div>

                                <div className="message-box ">
                                  {message?.media &&
                                  Array.isArray(message.media)
                                    ? message.media.map((mediaItem, index) => {
                                        const { folder, mediaType } =
                                          getMediaInfo(mediaItem);
                                        const mediaUrl = `${cloudFrontUrl}/${folder}/${mediaItem?.id}`;

                                        return (
                                          <div
                                            key={mediaItem.id || index}
                                            className="media-container"
                                          >
                                            {mediaType === "VIDEO" ? (
                                              <div
                                                className="relative cursor-pointer group"
                                                onClick={() =>
                                                  handleVideoClick(mediaUrl)
                                                }
                                              >
                                                <video
                                                  className="media-video"
                                                  style={{
                                                    maxWidth: "100%",
                                                    borderRadius: "8px",
                                                    pointerEvents: "none",
                                                  }}
                                                >
                                                  <source
                                                    src={mediaUrl}
                                                    type="video/mp4"
                                                  />
                                                  Your browser does not support
                                                  the video tag.
                                                </video>
                                                <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors rounded-lg">
                                                  <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center shadow-lg">
                                                    <div className="w-0 h-0 border-l-12 border-l-black border-y-8 border-y-transparent ml-1"></div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : mediaType === "AUDIO" ||
                                              mediaType === "VOICE" ? (
                                              <div className="flex flex-col items-center">
                                                <audio
                                                  controls
                                                  className="media-audio w-full min-w-62.5"
                                                  style={{
                                                    width: "100%",
                                                    minWidth: "250px",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#f0f2f5",
                                                    padding: "5px",
                                                  }}
                                                >
                                                  <source src={mediaUrl} />
                                                  Your browser does not support
                                                  the audio tag.
                                                </audio>
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    marginTop: "4px",
                                                    wordBreak: "break-all",
                                                  }}
                                                >
                                                  {mediaItem?.name}
                                                </div>
                                              </div>
                                            ) : mediaType === "IMAGE" ? (
                                              <img
                                                src={mediaUrl}
                                                alt={mediaItem?.name}
                                                onClick={() =>
                                                  handleImageClick(mediaUrl)
                                                }
                                                className="media-image cursor-pointer"
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.src =
                                                    "fallback-image-url";
                                                }}
                                              />
                                            ) : mediaType === "PDF" ? (
                                              <a
                                                href={mediaUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pdf-link"
                                              >
                                                <AiOutlineFilePdf size={35} />
                                                {mediaItem?.name}
                                              </a>
                                            ) : (
                                              <img
                                                src={mediaUrl}
                                                alt={mediaItem?.name}
                                                onClick={() =>
                                                  handleImageClick(mediaUrl)
                                                }
                                                className="media-image cursor-pointer"
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.src =
                                                    "fallback-image-url";
                                                }}
                                              />
                                            )}
                                          </div>
                                        );
                                      })
                                    : message?.media && (
                                        <div className="media-container">
                                          {(() => {
                                            const { folder, mediaType } =
                                              getMediaInfo(message.media);
                                            const mediaUrl = `${cloudFrontUrl}/${folder}/${message.media?.id}`;

                                            if (mediaType === "VIDEO") {
                                              return (
                                                <div
                                                  className="relative cursor-pointer group"
                                                  onClick={() =>
                                                    handleVideoClick(mediaUrl)
                                                  }
                                                >
                                                  <video
                                                    className="media-video"
                                                    style={{
                                                      maxWidth: "100%",
                                                      borderRadius: "8px",
                                                      pointerEvents: "none",
                                                    }}
                                                  >
                                                    <source
                                                      src={mediaUrl}
                                                      type="video/mp4"
                                                    />
                                                    Your browser does not
                                                    support the video tag.
                                                  </video>
                                                  <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors rounded-lg">
                                                    <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center shadow-lg">
                                                      <div className="w-0 h-0 border-l-12 border-l-black border-y-8 border-y-transparent ml-1"></div>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              mediaType === "AUDIO" ||
                                              mediaType === "VOICE"
                                            ) {
                                              return (
                                                <div className="flex flex-col items-center">
                                                  <audio
                                                    controls
                                                    className="media-audio w-full min-w-62.5"
                                                    style={{
                                                      width: "100%",
                                                      minWidth: "250px",
                                                      borderRadius: "8px",
                                                      backgroundColor:
                                                        "#f0f2f5",
                                                      padding: "5px",
                                                    }}
                                                  >
                                                    <source src={mediaUrl} />
                                                    Your browser does not
                                                    support the audio tag.
                                                  </audio>
                                                  <div
                                                    style={{
                                                      fontSize: "12px",
                                                      marginTop: "4px",
                                                      wordBreak: "break-all",
                                                    }}
                                                  >
                                                    {message.media?.name}
                                                  </div>
                                                </div>
                                              );
                                            } else if (mediaType === "IMAGE") {
                                              return (
                                                <img
                                                  src={mediaUrl}
                                                  alt={message?.media?.name}
                                                  onClick={() =>
                                                    handleImageClick(mediaUrl)
                                                  }
                                                  className="media-image cursor-pointer"
                                                  onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src =
                                                      "fallback-image-url";
                                                  }}
                                                />
                                              );
                                            } else if (mediaType === "PDF") {
                                              return (
                                                <a
                                                  href={mediaUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="pdf-link"
                                                >
                                                  <AiOutlineFilePdf size={35} />
                                                  {message.media?.name}
                                                </a>
                                              );
                                            } else {
                                              return (
                                                <img
                                                  src={mediaUrl}
                                                  alt={message?.media?.name}
                                                  onClick={() =>
                                                    handleImageClick(mediaUrl)
                                                  }
                                                  className="media-image cursor-pointer"
                                                  onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src =
                                                      "fallback-image-url";
                                                  }}
                                                />
                                              );
                                            }
                                          })()}
                                        </div>
                                      )}
                                  {message?.message}

                                  <Modal
                                    visible={isModalVisible}
                                    footer={null}
                                    onCancel={handleCancel}
                                    centered
                                  >
                                    <img
                                      src={modalImageSrc}
                                      alt="Preview"
                                      style={{
                                        width: "100%",
                                        marginTop: "20px",
                                      }}
                                    />
                                  </Modal>
                                </div>
                                <Popconfirm
                                  title="Are you sure to delete?"
                                  onConfirm={() => deleteMessage(message?._id)}
                                  okText="Yes"
                                  cancelText="No"
                                >
                                  <Button
                                    danger
                                    shape="circle"
                                    icon={
                                      <DeleteOutlined
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      />
                                    }
                                  />
                                </Popconfirm>
                              </div>
                            </div>
                          );
                        },
                      )}
                  </div>
                  <div>
                    {uploadedDocs && uploadedDocs?.length > 0 && (
                      <div
                        className="flex overflow-auto"
                        style={{ marginLeft: "40px" }}
                      >
                        {uploadedDocs.map((doc, index) => (
                          <Card
                            key={index}
                            size="small"
                            className="mb-2"
                            bodyStyle={{
                              padding: "8px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div className="flex items-center">
                              <AiOutlineFile style={{ marginRight: "4px" }} />
                              <span className="truncate">{doc.name}</span>
                            </div>
                            <Button
                              type="text"
                              icon={
                                <AiOutlineClose
                                  style={{ marginLeft: "12px" }}
                                />
                              }
                              onClick={() => onRemove(index)}
                              style={{ marginLeft: "auto" }}
                            />
                          </Card>
                        ))}
                      </div>
                    )}
                    <div className=" flex items-center gap-4">
                      <div className="flex  flex-col" style={{ gap: "10px" }}>
                        <AiOutlineUpload
                          size={25}
                          className="cursor-pointer"
                          onClick={() =>
                            document.getElementById("fileInput").click()
                          }
                        />
                        <input
                          id="fileInput"
                          type="file"
                          style={{ display: "none" }}
                          multiple
                          accept=".pdf, .jpeg, .jpg, .png, .mp3, .mp4, .wav, .webm"
                          onChange={handleFileSelect}
                        />
                      </div>
                      <SpellCheckTextArea
                        rows={3}
                        ref={inputRef}
                        placeholder="Type message..."
                        className="w-full border focus:outline-none resize-none"
                        value={messageData}
                        onChange={handleMessageChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSubmit();
                          }
                        }}
                      />
                      {((messageData && messageData.trim().length > 0) ||
                        uploadedDocs?.length > 0) && (
                        <Button
                          size="large"
                          type="primary"
                          onClick={handleSubmit}
                        >
                          Send
                        </Button>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className="flex justify-center items-center h-full w-full">
                  No message found
                </div>
              )}
            </div>
          </div>
          <div className="flex"></div>
        </div>
      </div>

      <Modal
        visible={videoModalVisible}
        footer={null}
        onCancel={() => {
          setVideoModalVisible(false);
          setSelectedVideo(null);
        }}
        width={800}
        centered
        destroyOnClose
        bodyStyle={{ padding: 0, backgroundColor: "black" }}
      >
        {selectedVideo && (
          <video
            controls
            autoPlay
            style={{ width: "100%", maxHeight: "80vh", display: "block" }}
          >
            <source src={selectedVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
      </Modal>
    </div>
  );
};

export default InstructorClassBroadcast;
